module.exports = __webpack_public_path__ + "img/logo_24.d7d61c35.png";